<template>
  <div class="container">
    <text-input
      v-mask="'##-########-#'"
      :hint="hint"
      :label="label"
      pattern="[0-9]*"
      inputmode="numeric"
      @input="onInput"
      @click="$emit('click')"
      :value="value"
      :required="required"
      :subhint="subhint"
      :validationError="validationError"
    />
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import TextInput from "@/components/core/TextInput";
import { isValidCuil } from "@/utils";

export default {
  name: "CuitField",
  components: { TextInput },
  directives: {
    mask
  },
  props: {
    value: String,
    label: String,
    hint: String,
    required: Boolean,
    subhint: String
  },
  data() {
    return {
      validationError: null,
      checked: false
    };
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
      if (this.checked) {
        this.isValid(val);
      }
    },

    checkValid() {
      this.checked = true;
      return this.isValid();
    },

    isValid(val) {
      // Por problema de sincronía con v-bind, paso el valor
      // por parámetro en onInput
      let value = val ? val : this.value;

      /* Sobreescribir método de validación */
      if (value && !isValidCuil(value.replace(/\D/g, ""))) {
        // Cuit no válido
        this.validationError = "El CUIT no es válido";
        return false;
      }

      // Cuit válido
      this.validationError = null;
      return true;
    }
  }
};
</script>

<style scoped></style>
